
// Universal Analytics is dead, and its replacement (Cloudflare Web Analytics)
// has no custom events API: no-op until the self-hosted Umami plan lands.
const analytics = {
    emit: function () {}
}

export default analytics


